import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyBar() {
  return <div className="fixed top-0 left-0 w-full bg-red-600 z-50 shadow-md" data-id="element-222">
      <div className="max-w-4xl mx-auto px-4 py-2 flex items-center justify-center space-x-3 md:space-x-6" data-id="element-223">
        <span className="text-white font-semibold text-sm md:text-base uppercase tracking-wide" data-id="element-224">
          Questa offerta scade presto
        </span>
        <CountdownTimer variant="white" size="sm" data-id="element-225" />
      </div>
    </div>;
}